import { Button } from '@mui/material';

const HiddenDialogButton = () => {
  return (
    <Button
      aria-hidden="true"
      tabIndex={-1}
      sx={{
        p: 0,
        '&:focus': {
          outline: 'none',
        },
      }}
      autoFocus
    />
  );
};

export default HiddenDialogButton;
